import { Modal } from '@bp/ui-components';
import type { BpClassType } from 'pages/Institution/subpages/InstitutionClassesSubpage';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { UsedColors } from 'utils/colorHelper';
import { ClassForm } from '../forms/ClassForm';

export type ClassesListModalProps = {
  selectedClass?: BpClassType;
  schoolYearUuid: string;
  colorsInUse: (UsedColors | null)[];
  isOpen: boolean;
  onClose: () => void;
};

export const ClassesListModal = ({
  selectedClass,
  schoolYearUuid,
  colorsInUse,
  isOpen,
  onClose,
}: ClassesListModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      loading={loading}
      title={selectedClass ? t('classes.edit') : t('classes.add')}
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <ClassForm
        selectedClass={selectedClass}
        schoolYearUuid={schoolYearUuid}
        colorsInUse={colorsInUse}
        onLoad={setLoading}
        onClose={onClose}
      />
    </Modal>
  );
};
